import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Menu from '../Menu';
import useApiUrls from '../../useApiUrls';
import { useNavigate, useParams } from "react-router-dom";

const SendAWSIOTCore = () => {
  const { merchant, pos } = useParams();
  const { getUrlByOperation } = useApiUrls();
  const [activeTab, setActiveTab] = useState("single");
  const [merchantname, setMerchantname] = useState(merchant || "All");
  const [posid, setPosid] = useState(pos || "0");
  const [AWSIOTCoreid, setAWSIOTCoreid] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [merchantList, setMerchantList] = useState([]);
  const [posList, setPosList] = useState([]);
  const [AWSIOTCoreList, setAWSIOTCoreList] = useState([]);

  // Group AWSIOTCore states
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [actionName, setActionName] = useState("");
  const [withAction, setWithAction] = useState(true);
  const [groupMessage, setGroupMessage] = useState("");
  const [groupLoading, setGroupLoading] = useState(false);
  const [groupResponseData, setGroupResponseData] = useState(null);
  const [groupErrorMessage, setGroupErrorMessage] = useState("");

  // SubGroup AWSIOTCore states
  const [selectedSubGroupsAWSIOTCore, setSelectedSubGroupsAWSIOTCore] = useState([]);
  const [subGroupAWSIOTCoreId, setSubGroupAWSIOTCoreId] = useState("");
  const [subGroupAWSIOTCoreLoading, setSubGroupAWSIOTCoreLoading] = useState(false);
  const [subGroupAWSIOTCoreResponseData, setSubGroupAWSIOTCoreResponseData] = useState(null);
  const [subGroupAWSIOTCoreErrorMessage, setSubGroupAWSIOTCoreErrorMessage] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch merchants when dropdown is focused
  const fetchMerchants = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    try {
      const response = await axios.get(
        "https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/merchantid",
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            accept: "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        const merchants = response.data.data.map((item) => item.merchantid);
        setMerchantList(merchants);
      }
    } catch (error) {
      console.error("Error fetching merchant list:", error);
      if (error.message === "relogin token expire") {
        navigate("/login");
      }
    }
  };

  // Fetch POS IDs based on the selected merchant
  const fetchPosByMerchant = async (merchantId) => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const posGetDistinct = getUrlByOperation("posGetDistinct");


    if (!posGetDistinct) {
      console.error("URL for posGetDistinct operation not found.");
      return;
    }

    const url = new URL(`specificmerchantid/${merchantId}`, posGetDistinct).toString();


    try {
      const response = await axios.get(url, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          accept: "text/plain",
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        setPosList(response.data.data.map((item) => ({
          id: item.id,
          value: item.value,
        })));
      } else {
        setPosList([]);
        console.warn("POS list is empty or in unexpected format.");
      }
    } catch (error) {
      console.error("Error fetching POS list:", error.message);
      console.debug("Error details:", error.response || error);
    }
  };

  // Fetch AWSIOTCore IDs from the search API
  // const fetchAWSIOTCoreds = async () => {
  //   // const localStorageData = JSON.parse(localStorage.getItem("user"));
  //   // const token = localStorageData?.token;
  //   // const userid = localStorageData?.userid;
  //   const token = getCookie("token");
  //   const userid = getCookie("userid");

  //   if (!token || !userid) {
  //     console.error("Missing token or userId in localStorage");
  //     return;
  //   }

  //   const requestBody = {
  //     id: 0,
  //     applycreateddate: false,
  //     fromcreateddate: 0,
  //     endcreateddate: 0,
  //     active: "",
  //     AWSIOTCorename: "",
  //     ispageload: false,
  //     pagesize: 10,
  //     currentpageno: 0,
  //     withoutpagination: false,
  //     pagedirection: "",
  //   };

  //   try {
  //     const AWSIOTCoreSearch = getUrlByOperation("CatalogSearch");
  //     const response = await axios.post(
  //       'https://api.dqr-display-tms.eventum.co.in/api/AWSIOTCorePackOperation/GetDistinct/name',
  //       // requestBody,
  //       {
  //         headers: {
  //           "X-Authorization": token,
  //           UserId: userid,
  //           "Content-Type": "application/json",

  //         },
  //       }
  //     );

  //     if (response.data && Array.isArray(response.data.data)) {
  //       setAWSIOTCoreList(response.data.data); // Set the AWSIOTCore list with data from the API
  //     
  //     } else {
  //       setAWSIOTCoreList([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching AWSIOTCore IDs:", error);
  //   }
  // };

  // Fetch AWSIOTCore IDs from the search API
  const fetchAWSIOTCoreIds = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    const requestBody = {
      ispageload: false,
      pagesize: 1000,
      currentpageno: 0,
      withoutpagination: false,
      pagedirection: "",
    };

    try {
      const response = await axios.post(
        "https://api.dqr-display-tms.eventum.co.in/api/AWSIOTCoreSettingOperation/Search",
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setAWSIOTCoreList(response.data.data);
      } else {
        setAWSIOTCoreList([]);
      }
    } catch (error) {
      console.error("Error fetching AWSIOTCore IDs:", error);
    }
  };

  // Fetch groups and subgroups
  const fetchGroups = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    try {
      const response = await axios.get(
        "https://api.dqr-display-tms.eventum.co.in/api/SubGroupOperation/GroupAndSubGroup",
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            accept: "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setGroupList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  // Handle group selection (select all subgroups in a group)
  const handleGroupSelect = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata) return;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    const allSelected = subgroupIds.every((id) =>
      selectedSubGroupsAWSIOTCore.includes(id)
    );

    if (allSelected) {
      // Deselect all subgroups in this group
      setSelectedSubGroupsAWSIOTCore(
        selectedSubGroupsAWSIOTCore.filter((id) => !subgroupIds.includes(id))
      );
    } else {
      // Select all subgroups in this group
      const newSelection = [...selectedSubGroupsAWSIOTCore];
      subgroupIds.forEach((id) => {
        if (!newSelection.includes(id)) {
          newSelection.push(id);
        }
      });
      setSelectedSubGroupsAWSIOTCore(newSelection);
    }
  };

  // Handle individual subgroup selection
  const handleSubGroupSelect = (subgroupId) => {
    if (selectedSubGroupsAWSIOTCore.includes(subgroupId)) {
      setSelectedSubGroupsAWSIOTCore(
        selectedSubGroupsAWSIOTCore.filter((id) => id !== subgroupId)
      );
    } else {
      setSelectedSubGroupsAWSIOTCore([...selectedSubGroupsAWSIOTCore, subgroupId]);
    }
  };

  // Check if all subgroups in a group are selected
  const isGroupFullySelected = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)
      return false;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    return subgroupIds.every((id) => selectedSubGroupsAWSIOTCore.includes(id));
  };

  // Check if some (but not all) subgroups in a group are selected
  const isGroupPartiallySelected = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)
      return false;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    const selectedCount = subgroupIds.filter((id) =>
      selectedSubGroupsAWSIOTCore.includes(id)
    ).length;

    return selectedCount > 0 && selectedCount < subgroupIds.length;
  };

  // Get selected subgroup names for display
  const getSelectedSubGroupNames = () => {
    const names = [];
    groupList.forEach((group) => {
      if (group.subgroupdata) {
        group.subgroupdata.forEach((sg) => {
          if (selectedSubGroupsAWSIOTCore.includes(sg.id)) {
            names.push(sg.name);
          }
        });
      }
    });
    return names;
  };

  // Function to handle the API call
  const handleSendAWSIOTCore = async () => {
    setLoading(true);
    const token = getCookie("token");
    const userid = getCookie("userid");

    const apiUrl =
      "@https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/AWSIOTCo";
    const requestBody = {
      merchantname,
      posid: posid || "0",
      AWSIOTCoreid: parseInt(AWSIOTCoreid),
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json",
        },
      });

      if (response.data && response.data.sendresult) {
        setResponseData(response.data.sendresult);
        setErrorMessage("");
      } else {
        setResponseData([
          {
            merchantname: merchantname,
            posname: posid || "All",
            responsestatus: response.data.responsestatus || "FAIL",
            errormsg: response.data.errormsg || "No matching records found",
          },
        ]);
        setErrorMessage("");
      }

      setLoading(false);
    } catch (error) {
      console.error("Error sending AWSIOTCore:", error);
      setLoading(false);
    }
  };

  // Function to handle Send AWSIOTCore to SubGroup API call
  const handleSendAWSIOTCoreToSubGroup = async () => {
    if (selectedSubGroupsAWSIOTCore.length === 0) {
      setSubGroupAWSIOTCoreErrorMessage("Please select at least one subgroup");
      return;
    }

    if (!subGroupAWSIOTCoreId) {
      setSubGroupAWSIOTCoreErrorMessage("Please select a AWSIOTCore");
      return;
    }

    setSubGroupAWSIOTCoreLoading(true);
    const token = getCookie("token");
    const userid = getCookie("userid");

    const apiUrl =
      "@https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/AWSIOTCore";
    const requestBody = {
      subgroupids: selectedSubGroupsAWSIOTCore,
      AWSIOTCoreid: parseInt(subGroupAWSIOTCoreId),
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          accept: "text/plain",
          "Content-Type": "application/json-patch+json",
        },
      });

      if (response.data) {
        setSubGroupAWSIOTCoreResponseData(response.data);
        setSubGroupAWSIOTCoreErrorMessage("");
        setSelectedSubGroupsAWSIOTCore([]);
        setSubGroupAWSIOTCoreId("");
      }

      setSubGroupAWSIOTCoreLoading(false);
    } catch (error) {
      console.error("Error sending AWSIOTCore to subgroup:", error);
      setSubGroupAWSIOTCoreErrorMessage(
        error.response?.data?.errormsg || "Error sending AWSIOTCore to subgroup"
      );
      setSubGroupAWSIOTCoreLoading(false);
    }
  };

  useEffect(() => {
    fetchAWSIOTCoreIds();
    fetchGroups();
  }, []);

  return (
    <>
      <Menu />
      <div className="content-wrapper" style={{ padding: "20px" }}>
        {/* Tab Navigation */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
            backgroundColor: "var(--surface)",
            borderRadius: "8px",
            width: "400px",
            margin: "0 auto 20px",
            borderBottom: "1px solid var(--border)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <button
            style={{
              flex: 1,
              padding: "12px",
              backgroundColor:
                activeTab === "single" ? "var(--info)" : "transparent",
              color: activeTab === "single" ? "#fff" : "var(--text)",
              border: "none",
              cursor: "pointer",
              borderRadius: "8px 0 0 0",
              fontWeight: activeTab === "single" ? "bold" : "normal",
              transition: "all 0.3s ease",
            }}
            onClick={() => setActiveTab("single")}
          >
            Single
          </button>
          <button
            style={{
              flex: 1,
              padding: "12px",
              backgroundColor:
                activeTab === "group" ? "var(--info)" : "transparent",
              color: activeTab === "group" ? "#fff" : "var(--text)",
              border: "none",
              cursor: "pointer",
              borderRadius: "0 8px 0 0",
              fontWeight: activeTab === "group" ? "bold" : "normal",
              transition: "all 0.3s ease",
            }}
            onClick={() => setActiveTab("group")}
          >
            Group
          </button>
        </div>

        {/* Single Tab Content */}
        {activeTab === "single" && (
          <div
            style={{
              backgroundColor: "var(--surface)",
              padding: "2rem",
              borderRadius: "8px",
              width: "400px",
              margin: "auto",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <h4 style={{ marginBottom: "20px" }}>Send AWSIOTCore</h4>
            <div className="form-group">
              <label>Merchant Name</label>
              {merchant ? (
                <select className="form-control" value={merchantname} disabled>
                  <option value={merchant}>{merchant}</option>
                </select>
              ) : (
                <select
                  className="form-control"
                  value={merchantname}
                  onChange={(e) => {
                    const selectedMerchant = e.target.value;
                    setMerchantname(selectedMerchant);
                    setPosid("");
                    if (selectedMerchant) {
                      fetchPosByMerchant(selectedMerchant);
                    } else {
                      setPosList([]);
                    }
                  }}
                  onFocus={fetchMerchants}
                >
                  <option value="Select">Select</option>
                  <option value="All">All</option>
                  {merchantList.map((merchant, index) => (
                    <option key={index} value={merchant}>
                      {merchant}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className="form-group">
              <label>POS ID</label>
              {pos ? (
                <select className="form-control" value={posid} disabled>
                  <option value={pos}>{pos}</option>
                </select>
              ) : (
                <select
                  className="form-control"
                  value={posid}
                  onChange={(e) => setPosid(e.target.value)}
                  disabled={!merchantname}
                  style={{ backgroundColor: "var(--surface)", color: "var(--text)" }}
                >
                  <option value="0">All</option>
                  {posList.map((pos, index) => (
                    <option key={index} value={pos.id}>
                      {pos.value}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className="form-group">
              <label>AWSIOTCore ID</label>
              <select
                className="form-control"
                value={AWSIOTCoreid}
                onChange={(e) => setAWSIOTCoreid(e.target.value)}
              >
                <option value="">Select AWSIOTCore</option>
                {AWSIOTCoreList.map((AWSIOTCore, index) => (
                  <option key={index} value={AWSIOTCore.id}>
                    {AWSIOTCore.deviceid}

                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <button
                className="btn btn-primary"
                onClick={handleSendAWSIOTCore}
                disabled={loading || !AWSIOTCoreid}
              >
                {loading ? "Sending..." : "Send AWSIOTCore"}
              </button>
            </div>
          </div>
        )}

        {/* Group Tab Content */}
        {activeTab === "group" && (
          <div
            style={{
              backgroundColor: "var(--surface)",
              padding: "2rem",
              borderRadius: "8px",
              width: "600px",
              margin: "auto",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <h4 style={{ marginBottom: "20px" }}>
              Send AWSIOTCore to SubGroup
            </h4>

            <div className="form-group" style={{ position: "relative", zIndex: 50 }}>
              <label>AWSIOTCore</label>
              <select
                className="form-control"
                value={subGroupAWSIOTCoreId}
                onChange={(e) => setSubGroupAWSIOTCoreId(e.target.value)}
              >
                <option value="">Select AWSIOTCore</option>
                {AWSIOTCoreList.map((AWSIOTCore, index) => (
                  <option key={index} value={AWSIOTCore.id}>
                    {AWSIOTCore.deviceid}

                  </option>
                ))}
              </select>
            </div>

            <div className="form-group" style={{ position: "relative", zIndex: 100 }}>
              <label>Select Subgroups</label>
              <div ref={dropdownRef} style={{ position: "relative" }}>
                {/* Dropdown Toggle */}
                <div
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    backgroundColor: "var(--surface)",
                    minHeight: "38px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: selectedSubGroupsAWSIOTCore.length === 0 ? "#999" : "#333" }}>
                    {selectedSubGroupsAWSIOTCore.length === 0
                      ? "Select subgroups..."
                      : `${selectedSubGroupsAWSIOTCore.length} subgroup(s) selected`}
                  </span>
                  <i
                    className={`fas fa-chevron-${isDropdownOpen ? "up" : "down"
                      }`}
                    style={{ color: "var(--text)" }}
                  ></i>
                </div>

                {/* Dropdown Menu */}
                {isDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "var(--surface)",
                      border: "1px solid var(--border)",
                      borderRadius: "4px",
                      marginTop: "4px",
                      maxHeight: "400px",
                      overflowY: "auto",
                      zIndex: 10000,
                      boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                      backgroundColor: "var(--surface, #ffffff)",
                    }}
                  >
                    {groupList.length > 0 ? (
                      groupList.map((group) => (
                        <div key={group.id}>
                          {group.subgroupdata &&
                            group.subgroupdata.length > 0 && (
                              <div>
                                {/* Group Header */}
                                <div
                                  onClick={() => handleGroupSelect(group.id)}
                                  style={{
                                    padding: "10px 15px",
                                    backgroundColor: "var(--surface2)",
                                    borderBottom: "1px solid var(--border)",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                    transition: "background-color 0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "var(--surface)")
                                  }
                                  onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "#f8f9fa")
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    checked={isGroupFullySelected(group.id)}
                                    ref={(input) => {
                                      if (input) {
                                        input.indeterminate =
                                          isGroupPartiallySelected(group.id);
                                      }
                                    }}
                                    onChange={() => { }}
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      marginRight: "10px",
                                      cursor: "pointer",
                                      accentColor: "var(--info)",
                                    }}
                                  />
                                  <i
                                    className="fas fa-folder"
                                    style={{ marginRight: "8px", color: "var(--text)" }}
                                  ></i>
                                  {group.name}
                                  <span
                                    style={{
                                      marginLeft: "auto",
                                      fontSize: "12px",
                                      color: "var(--text-muted)",
                                      backgroundColor: "var(--surface)",
                                      padding: "2px 8px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    {group.subgroupdata.length}
                                  </span>
                                </div>

                                {/* Subgroups */}
                                {group.subgroupdata.map((subgroup) => (
                                  <div
                                    key={subgroup.id}
                                    onClick={() =>
                                      handleSubGroupSelect(subgroup.id)
                                    }
                                    style={{
                                      padding: "8px 15px 8px 45px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      borderBottom: "1px solid var(--border)",
                                      backgroundColor:
                                        selectedSubGroupsAWSIOTCore.includes(
                                          subgroup.id
                                        )
                                          ? "var(--info-dim)"
                                          : "var(--surface)",
                                      transition: "background-color 0.2s",
                                    }}
                                    onMouseEnter={(e) => {
                                      if (
                                        !selectedSubGroupsAWSIOTCore.includes(
                                          subgroup.id
                                        )
                                      ) {
                                        e.currentTarget.style.backgroundColor =
                                          "var(--surface2)";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (
                                        !selectedSubGroupsAWSIOTCore.includes(
                                          subgroup.id
                                        )
                                      ) {
                                        e.currentTarget.style.backgroundColor =
                                          "#fff";
                                      }
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedSubGroupsAWSIOTCore.includes(
                                        subgroup.id
                                      )}
                                      onChange={() => { }}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "10px",
                                        cursor: "pointer",
                                        accentColor: "var(--info)",
                                      }}
                                    />
                                    <i
                                      className="fas fa-layer-group"
                                      style={{
                                        marginRight: "8px",
                                        color: "var(--text)",
                                        fontSize: "12px",
                                      }}
                                    ></i>
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        color: selectedSubGroupsAWSIOTCore.includes(
                                          subgroup.id
                                        )
                                          ? "var(--info)"
                                          : "var(--text)",
                                      }}
                                    >
                                      {subgroup.name}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#999",
                        }}
                      >
                        No subgroups available
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Selected Items Display */}
              {selectedSubGroupsAWSIOTCore.length > 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    padding: "10px",
                    backgroundColor: "var(--info-dim)",
                    borderRadius: "4px",
                    border: "1px solid #90caf9",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <i
                      className="fas fa-check-circle"
                      style={{ color: "var(--info)", marginRight: "8px" }}
                    ></i>
                    <strong style={{ color: "var(--info)", fontSize: "13px" }}>
                      {selectedSubGroupsAWSIOTCore.length} subgroup(s) selected
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      maxHeight: "100px",
                      overflowY: "auto",
                    }}
                  >
                    {getSelectedSubGroupNames().map((name, index) => (
                      <span
                        key={index}
                        style={{
                          backgroundColor: "var(--surface)",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          color: "var(--text)",
                          border: "1px solid var(--info)",
                        }}
                      >
                        {name}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1.5rem",
              }}
            >
              <button
                className="btn btn-primary btn-lg"
                onClick={handleSendAWSIOTCoreToSubGroup}
                disabled={
                  subGroupAWSIOTCoreLoading ||
                  selectedSubGroupsAWSIOTCore.length === 0 ||
                  !subGroupAWSIOTCoreId
                }
                style={{ flex: 1 }}
              >
                {subGroupAWSIOTCoreLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm mr-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane mr-2"></i>
                    Send AWSIOTCore to SubGroup
                  </>
                )}
              </button>
            </div>

            {subGroupAWSIOTCoreErrorMessage && (
              <div
                className="alert alert-danger mt-3"
                style={{ fontSize: "14px" }}
              >
                <i className="fas fa-exclamation-circle mr-2"></i>
                {subGroupAWSIOTCoreErrorMessage}
              </div>
            )}
            {subGroupAWSIOTCoreResponseData && (
              <div
                className="alert alert-success mt-3"
                style={{ fontSize: "14px" }}
              >
                <i className="fas fa-check-circle mr-2"></i>
                AWSIOTCore sent to subgroup(s) successfully!
              </div>
            )}
          </div>
        )}

        <section className="content">
          <div className="container-fluid">
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="card shadow-sm">
                  <div className="card-header" style={{ backgroundColor: "var(--surface)", borderBottom: "1px solid var(--border)" }}>
                    <h3 className="card-title" style={{ color: "var(--text)" }}>
                      <i className="fas fa-chart-line mr-2"></i>
                      AWSIOTCore Response Results
                    </h3>
                  </div>
                  <div className="card-body table-responsive p-0">
                    <table className="table table-hover table-striped mb-0">
                      <thead style={{ backgroundColor: "var(--surface2)" }}>
                        <tr>
                          <th style={{ color: "var(--text)", borderColor: "var(--border)" }}>Type</th>
                          <th style={{ color: "var(--text)", borderColor: "var(--border)" }}>Merchant Name</th>
                          <th style={{ color: "var(--text)", borderColor: "var(--border)" }}>POS Name</th>
                          <th style={{ color: "var(--text)", borderColor: "var(--border)" }}>Response Status</th>
                          <th style={{ color: "var(--text)", borderColor: "var(--border)" }}>Message/Error</th>
                          <th style={{ color: "var(--text)", borderColor: "var(--border)" }}>Status Badge</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Display Single AWSIOTCore Results */}
                        {responseData &&
                          responseData.length > 0 &&
                          responseData.map((result, index) => (
                            <tr key={`single-${index}`}>
                              <td>
                                <span className="badge badge-info">Single</span>
                              </td>
                              <td>{result.merchantname || "-"}</td>
                              <td>{result.posname || "-"}</td>
                              <td>{result.responsestatus || "-"}</td>
                              <td>{result.errormsg || "-"}</td>
                              <td>
                                {result.responsestatus === "SUCCESS" ? (
                                  <span className="badge badge-success">
                                    ✓ Success
                                  </span>
                                ) : (
                                  <span className="badge badge-danger">
                                    ✗ Failed
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}

                        {/* Display SubGroup AWSIOTCore Response Data */}
                        {subGroupAWSIOTCoreResponseData &&
                          subGroupAWSIOTCoreResponseData.sendresult &&
                          subGroupAWSIOTCoreResponseData.sendresult.length >
                          0 &&
                          subGroupAWSIOTCoreResponseData.sendresult.map(
                            (result, index) => (
                              <tr key={`subgroup-${index}`}>
                                <td>
                                  <span className="badge badge-secondary">
                                    SubGroup
                                  </span>
                                </td>
                                <td>{result.merchantname || "-"}</td>
                                <td>{result.posname || "-"}</td>
                                <td>{result.responsestatus || "-"}</td>
                                <td>{result.errormsg || "-"}</td>
                                <td>
                                  {result.responsestatus === "SUCCESS" ? (
                                    <span className="badge badge-success">
                                      ✓ Success
                                    </span>
                                  ) : (
                                    <span className="badge badge-danger">
                                      ✗ Failed
                                    </span>
                                  )}
                                </td>
                              </tr>
                            )
                          )}

                        {/* Show empty state when no data */}
                        {!responseData &&
                          !groupResponseData &&
                          !subGroupAWSIOTCoreResponseData && (
                            <tr>
                              <td
                                colSpan="6"
                                style={{
                                  textAlign: "center",
                                  padding: "40px 20px",
                                }}
                              >
                                <i
                                  className="fas fa-inbox"
                                  style={{
                                    fontSize: "3rem",
                                    color: "#ccc",
                                    marginBottom: "10px",
                                  }}
                                ></i>
                                <p style={{ color: "#999", marginBottom: 0 }}>
                                  {errorMessage ||
                                    groupErrorMessage ||
                                    subGroupAWSIOTCoreErrorMessage ||
                                    "No data available yet. Send a AWSIOTCore to see results here."}
                                </p>
                              </td>
                            </tr>
                          )}

                        {/* Show message when all are empty but we tried to send */}
                        {responseData &&
                          responseData.length === 0 &&
                          !groupResponseData &&
                          !subGroupAWSIOTCoreResponseData && (
                            <tr>
                              <td
                                colSpan="6"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  color: "#999",
                                }}
                              >
                                No results to display
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SendAWSIOTCore;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}